import React from 'react';
import ArticleField from '../ArticleField';
import StrapiMedia from '../StrapiMedia';

interface ImageProps {
    value: any[],
    onChange: (value: any[]) => void
}

const Image = (props: ImageProps) => (
    <ArticleField label="Image">
        <StrapiMedia type="image" value={props.value} onChange={props.onChange} />
    </ArticleField>
);

export default Image;